import BaseBusinessAPI from './baseBusinessAPI'

class SystemAPI extends BaseBusinessAPI {
    controllerName = 'Systems';

    /**
   * Đăng ký thông tin đơn vị và Tạo mới dữ liệu
   */

    /**
   * Lấy context data
   */
    async getContextData () {
      const request = {
        url: [this.getAPIUrl(), 'context-data'].join('/'),
      }

      return await this.getAsync(request)
    }

    /**
   * Lấy token kết nối ws
   * @returns
   * PVThang
   */
    async getWebSocketToken () {
      const request = {
        url: [this.getAPIUrl(), 'web-socket', 'token'].join('/'),
      }

      return await this.getAsync(request)
    }

    /**
     * Logout ứng dụng: clear cookie, session server
     */
    logoutApp () {
      const me = this
      const request = {
        url: [me.getAPIUrl(), 'logout'].join('/'),
      }

      return me.postAsync(request)
    }
}

export default new SystemAPI()
